import { cn } from '@rouvydev/web-components/utils'
import { Cols } from '~/components/cols.tsx'
import { Socials, type SocialTypes } from '~/components/socials'

type Props = {
  name: string
  jobTitle: string | null | undefined
  socials:
    | ({
        type: SocialTypes
        link: string
      } | null)[]
    | null
    | undefined
  avatar: string | undefined
  perex: string | null | undefined
  className?: string
}
export function AuthorHeader({
  name,
  jobTitle,
  socials,
  avatar,
  perex,
  className,
}: Props) {
  return (
    <div className="bg-background-default py-10 md:flex-row md:py-20">
      <div className="container">
        <Cols size="12">
          <div
            className={cn(
              'flex flex-col gap-6 md:flex-row md:gap-10',
              className,
            )}
          >
            {avatar && (
              <div className="flex">
                <div
                  className="h-[80px] w-[80px] rounded-full bg-cover bg-center md:h-[144px] md:w-[144px]"
                  style={{ backgroundImage: `url(${avatar})` }}
                ></div>
              </div>
            )}
            <div className="flex flex-col gap-4 md:gap-8 lg:w-[680px]">
              <div className="flex flex-col gap-4">
                <div className="font-display text-display-32 leading-10 font-extrabold text-global-white uppercase italic md:text-display-48">
                  {name}
                </div>
                <div className="text-[10px] leading-tight font-bold tracking-[4px] text-text-informative uppercase md:text-body-14 md:tracking-[6px]">
                  {jobTitle}
                </div>
              </div>

              <div className="text-body-16 leading-normal font-medium text-global-white md:text-body-18">
                {perex}
              </div>

              <div>
                {socials && <Socials socials={socials} variant="normal" />}
              </div>
            </div>
          </div>
        </Cols>
      </div>
    </div>
  )
}
